class MenuBlock extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.level2Details = this.querySelectorAll('[data-details-level-1]');
    this.summaries = this.querySelectorAll('summary');

    this.options = {
      level_2_open_by_default: false,
      level_2_open_by_default_mobile: false,
    };

    if (this?.dataset?.options) {
      this.options = {
        ...this.options,
        ...JSON.parse(this.dataset.options),
      };
    }

    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.summaries.forEach(summary => {
      summary.addEventListener('click', this.onSummaryClick);
    });

    if (this.options.level_2_open_by_default && this.options.level_2_open_by_default_mobile) {
      // skip, default are already open
      return;
    }
    else if (this.options.level_2_open_by_default) {
      document.addEventListener('DOMContentLoaded', () => (window.windowWidth >= 768) ? this.level2OpenByDefault() : this.level2ClosedByDefault());
      window.addEventListener('window:resize', () => (window.windowWidth >= 768) ? this.level2OpenByDefault() : this.level2ClosedByDefault());
    }
    else if (this.options.level_2_open_by_default_mobile) {
      document.addEventListener('DOMContentLoaded', () => (window.windowWidth < 768) ? this.level2OpenByDefault() : this.level2ClosedByDefault());
      window.addEventListener('window:resize', () => (window.windowWidth < 768) ? this.level2OpenByDefault() : this.level2ClosedByDefault());
    }
  }
  disconnectedCallback() {
    this.summaries.forEach(summary => {
      summary.removeEventListener('click', this.onSummaryClick);
    });
  }

  onSummaryClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const detail = e.target.parentElement;
    if (detail.matches(':open')) {
      if (e.target.dataset?.url !== '#') {
        window.location.href = e.target.dataset?.url;
      }
      else {
        detail.removeAttribute('open');
      }
    }
    else {
      detail.setAttribute('open', '');
    }
  }

  level2OpenByDefault() {
    this.level2Details.forEach(detail => {
      detail.setAttribute('open', '');
      const summary = detail.querySelector('summary');
      summary.querySelector('svg').classList.add('hidden');
      summary.classList.add('pointer-events-none');
    });
  }

  level2ClosedByDefault() {
    this.level2Details.forEach(detail => {
      detail.removeAttribute('open');
      const summary = detail.querySelector('summary');
      summary.querySelector('svg').classList.remove('hidden');
      summary.classList.remove('pointer-events-none');
    });
  }
}
if (!customElements.get('menu-block')) {
  customElements.define('menu-block', MenuBlock);
}